import { IConnectionDataKey } from '@typedream/core';
import { focusEditor, isCollapsed, select } from '@udecode/plate-core';
import { DreamEditor } from '../../../../types';
import { BLOCK_ELEMENT_KEY } from './types';

export const addConnectDataAtSelection = (
  editor: DreamEditor,
  collectionDataKeys: IConnectionDataKey[],
) => {
  if (!editor.selection) return;
  // Cannot add style if nothing is selected
  if (isCollapsed(editor.selection)) {
    return;
  }

  editor.removeMark(BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS);
  editor.addMark(BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS, collectionDataKeys);
  editor.addMark(BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA, true);

  focusEditor(editor);
};

export const removeConnectDataAtSelection = (
  editor: DreamEditor,
  options?: any,
) => {
  if (!editor.selection && !options) return;

  // Select if selection is collapsed
  if (isCollapsed(editor.selection)) {
    select(editor, options?.at || editor.selection?.anchor?.path);
  }

  editor.removeMark(BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA);
  editor.removeMark(BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS);

  focusEditor(editor);
};
